import React from 'react';

export default () => {
  const [, forceUpdate] = React.useState();
  return React.useCallback(() => {
    forceUpdate((s) => !s);
  }, []);
};
